// extracted by mini-css-extract-plugin
module.exports = {"quickAddCard":"QuickAddHoverBtnCard_quickAddCard__3Wq3G","quickAddBtn":"QuickAddHoverBtnCard_quickAddBtn__1LKNC"};